export var Modal = {
  baseStyle: {
    dialog: {
      borderRadius: '0.25rem'
    }
  }
};